import { twMerge } from 'tailwind-merge'

import { FlexProps } from './flex.type'

import { flexStyle } from './flex.css'

const Flex = <E extends React.ElementType = 'div'>({
  as,
  children,
  direction = 'horizontal',
  className,
  ref,
  ...props
}: FlexProps<E>) => {
  const Element = as || 'div'

  return (
    <Element className={twMerge(flexStyle({ direction }), className)} ref={ref} {...props}>
      {children}
    </Element>
  )
}

Flex.displayName = 'Flex'

export default Flex
